module.exports = __webpack_public_path__ + "static/media/pci-full.cbf1bf4f.png";